module.exports = __webpack_public_path__ + "img/headBg-lazy2.9893a2be.jpg";